import { ApolloClient, InMemoryCache } from "@apollo/client";
import { SetContextLink } from "@apollo/client/link/context";
import { HttpLink } from "@apollo/client/link/http";

import {
  REACT_APP_WUCA_API_CLIENT_URL,
  REACT_APP_WUCA_DXP_API_BEARER_TOKEN,
} from "./config";

const httplink = new HttpLink({
  uri: REACT_APP_WUCA_API_CLIENT_URL,
});

const authLink = new SetContextLink((prevContext, operation) => {
  return {
    headers: {
      ...prevContext.headers,
      authorization: `Bearer ${REACT_APP_WUCA_DXP_API_BEARER_TOKEN}`,
    },
  };
});

export const dxpClient = new ApolloClient({
  link: authLink.concat(httplink),
  cache: new InMemoryCache(),
});
